<template>
  <v-card>
    <v-card-title class="mb-10">{{ file.name }}</v-card-title>
    <v-card-text>
      <div class="position-relative media-holder">
        <Loader :loading="loading" class="rounded" block></Loader>
        <template v-if="fileUrl && fileType">
          <video v-if="fileType.includes('video')" autoplay playsinline width="100%" controls class="rounded">
            <source :src="fileUrl" :type="fileType" />
            Формат не поддерживается
          </video>
          <img v-if="fileType.includes('image')" width="100%" :src="fileUrl" alt="" class="rounded" />
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Loader from "@/components/Loader";
import { formModal } from "@/mixins/modal/form-modal";
import { buildDocumentUrl } from "@/services/utils";

export default {
  name: "SelectModalType",
  components: { Loader },
  mixins: [formModal],

  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      fileUrl: "",
      fileType: "",
    };
  },
  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  created() {
    this.loading = true;
    this.$http
      .get(buildDocumentUrl(this.customerId, this.file.id), { responseType: "blob" })
      .then(response => {
        this.fileUrl = URL.createObjectURL(response.data);
        this.fileType = response.data.type;
      })
      .catch(async () => {
        await this.$dialog.notify.error("Ошибка загрузки файла");
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.media-holder {
  height: 320px;
  overflow: hidden;
}
</style>
